export default __webpack_public_path__ + "static/media/location_white.665caaaf.png";